import React from "react";
import { Navigate, Route, Routes, BrowserRouter } from "react-router-dom";
import { css, ThemeProvider } from "@mui/material";
import { Global } from "@emotion/react";
import Constants from "./utils/constants";
import { DepartmentList, Authentication,Configuration, ShiftList, ShiftDetails } from "./features";
import Footer from './components/footer'
import { getLocalData } from "./services/storageManager";

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import theme from './theme'

const App = () => {
    if (window.location.pathname != Constants.ROUTES.AUTHENTICATION && !new URLSearchParams(window.location.search).get('code') && !getLocalData('accessToken')){
        window.location.assign(Constants.ROUTES.AUTHENTICATION);
    }

    return (
        <ThemeProvider theme={theme}>
            <Global
                styles={css`
                  html, body, #root {
                    height: 100%;
                    margin: unset;
                  }
                `}
            />
            <BrowserRouter>
                <Routes>
                    <Route exact path={Constants.ROUTES.SETUP_CONFIG} element={<Configuration />} />
                    <Route exact path={Constants.ROUTES.AUTHENTICATION} element={<Authentication />} />
                    <Route exact path={Constants.ROUTES.DEPARTMENT_LIST} element={<DepartmentList />} />
                    <Route exact path={Constants.ROUTES.DEPARTMENT_LIST + '/:departmentId' + Constants.ROUTES.SHIFT_LIST} element={<ShiftList />} />
                    <Route exact path={Constants.ROUTES.SHIFT_LIST + '/:shiftId'} element={<ShiftDetails />} />
                    <Route path="*" element={<Navigate to={Constants.ROUTES.DEPARTMENT_LIST} replace />} />
                </Routes>
            </BrowserRouter>
            <div id='snackbarhelper'></div>
            <Footer />
        </ThemeProvider>
    )
}

export default App;
